export default "__VITE_ASSET__RDZBGDGR__"